
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/whatsapp",
      function () {
        return require("private-next-pages/destinations/whatsapp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/whatsapp"])
      });
    }
  